import React, { useState } from "react";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { TextField, Popover, Box, Stack } from "@mui/material";

// import Accordion from "@mui/material/Accordion";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import AccordionDetails from "@mui/material/AccordionDetails";
// import Typography from "@mui/material/Typography";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

interface props {
	fetchData: any;
	deviceId: any;
	setFilterText: any;
}

const HistoryFilter: React.FC<props> = ({
	fetchData,
	deviceId,
	setFilterText,
}) => {
	const [dateStartRange, setDateStartRange] = useState("");
	const [dateEndRange, setDateEndRange] = useState("");
	const [rangeErrMsg, setRangeErrMsg] = useState(false);
	const [dateSpecific, setDateSpecific] = useState("");
	const [dateErrMsg, setDateErrMsg] = useState(false);

	const sqlConversion = (date: any) => {
		const offset = date.getTimezoneOffset();
		const localDate = new Date(date.getTime() - offset * 60000);
		return localDate.toISOString().slice(0, 19).replace("T", " ");
	};

	const rangeStart = (date: any) => {
		setDateStartRange(date.$d);
	};

	const rangeEnd = (date: any) => {
		setDateEndRange(date.$d);
	};

	const rangeFetch = () => {
		const startDate = new Date(dateStartRange);
		const endDate = new Date(dateEndRange);

		let diffTime = endDate.getTime() - startDate.getTime();
		let diffDays = Math.round(diffTime / (1000 * 3600 * 24));
		let agg;
		const type = "range";

		if (diffDays < 2) {
			agg = 1;
		} else if (diffDays >= 2 && diffDays < 61) {
			agg = 2;
		} else if (diffDays >= 61 && diffDays < 1441) {
			agg = 3;
		} else {
			agg = 4;
		}

		if (endDate > startDate) {
			// console.log("diff days", diffDays);
			// console.log("agg", agg);
			setRangeErrMsg(false);
			setFilterText(
				sqlConversion(startDate).replace(" 00:00:00", "") +
					" - " +
					sqlConversion(endDate).replace(" 00:00:00", "")
			);
			fetchData(
				deviceId,
				agg,
				type,
				sqlConversion(startDate),
				sqlConversion(endDate)
			);
		} else {
			setRangeErrMsg(true);
		}
	};

	const specificDate = (date: any) => {
		const startDate = new Date(date.$d);
		setFilterText(sqlConversion(startDate).replace(" 00:00:00", ""));
		fetchData(
			deviceId,
			1,
			"range",
			sqlConversion(startDate),
			sqlConversion(startDate)
		);
	};

	const dateFetch = () => {
		if (dateSpecific) {
			const startDate = new Date(dateSpecific);
			setDateErrMsg(false);
			setFilterText(sqlConversion(startDate).replace(" 00:00:00", ""));
			fetchData(
				deviceId,
				1,
				"range",
				sqlConversion(startDate),
				sqlConversion(startDate)
			);
		} else {
			setDateErrMsg(true);
		}
	};

	const [activeFilter, setActiveFilter] = useState("24");
	const [activeFilterDate, setActiveFilterDate] = useState<any>(null);

	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [startDate, setStartDate] = useState<Dayjs | null>(dayjs());
	const [endDate, setEndDate] = useState<Dayjs | null>(dayjs().add(0, "day"));

	const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	const formattedRange =
		startDate && endDate
			? `${startDate.format("YYYY-MM-DD")} to ${endDate.format("YYYY-MM-DD")}`
			: "";

	return (
		<div className="filter-div">
			{/* <h4>Filter</h4>
			<hr /> */}

			<button
				className="filter-btn"
				style={
					activeFilter === "24"
						? { backgroundColor: "#122178", color: "#ffffff" }
						: {}
				}
				onClick={() => {
					fetchData(
						deviceId,
						1,
						"24hour",
						new Date().toISOString,
						new Date().toISOString
					);
					setFilterText("Last 24 Hours");
					setActiveFilter("24");
					setActiveFilterDate(null);
				}}
			>
				Last 24 hours
			</button>
			<button
				className="filter-btn"
				style={
					activeFilter === "hour"
						? { backgroundColor: "#122178", color: "#ffffff" }
						: {}
				}
				onClick={() => {
					fetchData(
						deviceId,
						1,
						"hour",
						new Date().toISOString,
						new Date().toISOString
					);
					setFilterText("Last Hour");
					setActiveFilter("hour");
					setActiveFilterDate(null);
				}}
			>
				Last hour
			</button>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<DatePicker
					//label="Date"
					value={activeFilterDate}
					onChange={(date) => {
						specificDate(date);
						setActiveFilterDate(date);
						setActiveFilter("date");
					}}
					slotProps={{ textField: { size: "small" } }}
					className={activeFilter === "date" ? "date-picker" : "date-picker"}
					sx={
						activeFilter === "date"
							? {
									backgroundColor: "#122178",
									borderRadius: "8px",
									"& .MuiInputBase-input": {
										color: "#ffffff", // Text color inside the input
									},
									"& .MuiInputLabel-root": {
										color: "#ffffff", // Label color
									},
									"& .MuiSvgIcon-root": {
										color: "#ffffff", // Calendar icon color
									},
							  }
							: {}
					}
					//onClick={() => dateFetch()}
				/>
			</LocalizationProvider>
			<div
				className="range-picker"
				style={
					activeFilter === "range"
						? { backgroundColor: "#122178", color: "#ffffff" }
						: { marginLeft: "10px" }
				}
			>
				<LocalizationProvider dateAdapter={AdapterDayjs}>
					<TextField
						label="Date Range"
						value={formattedRange}
						onClick={handleOpen}
						fullWidth
					/>

					<Popover
						open={open}
						anchorEl={anchorEl}
						onClose={handleClose}
						anchorOrigin={{
							vertical: "bottom",
							horizontal: "left",
						}}
					>
						<Box p={2}>
							<Stack
								direction="row"
								spacing={2}
							>
								<DatePicker
									label="Start"
									className="date-picker"
									slotProps={{ textField: { size: "small" } }}
									onChange={(newValue) => {
										setStartDate(newValue);
										if (newValue && endDate && newValue.isAfter(endDate)) {
											setEndDate(newValue);
										}
										rangeStart(newValue);
									}}
								/>
								<DatePicker
									label="End"
									className="date-picker"
									slotProps={{ textField: { size: "small" } }}
									minDate={startDate ?? undefined}
									onChange={(newValue) => {
										rangeEnd(newValue);
										setEndDate(newValue);
									}}
								/>
								<button
									className="filter-btn"
									onClick={() => rangeFetch()}
								>
									Filter
								</button>
								{rangeErrMsg && (
									<p style={{ color: "red", fontSize: "12px" }}>
										Invalid Date Range
									</p>
								)}
							</Stack>
						</Box>
					</Popover>
				</LocalizationProvider>
			</div>
			{/* <Accordion className="filter-accordion">
				<AccordionSummary
					expandIcon={<ArrowDropDownIcon />}
					aria-controls="panel3-content"
					id="panel3-header"
				>
					<Typography component="span">Filter by Date</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DatePicker
							label="Select Date"
							onChange={(date) => specificDate(date)}
						/>
					</LocalizationProvider>
					{dateErrMsg ? (
						<p style={{ color: "red", fontSize: "12px" }}>Select date</p>
					) : null}
					<button
						className="filter-btn"
						onClick={() => dateFetch()}
					>
						Filter
					</button>
				</AccordionDetails>
			</Accordion> */}
			{/* <Accordion className="filter-accordion">
				<AccordionSummary
					expandIcon={<ArrowDropDownIcon />}
					aria-controls="panel2-content"
					id="panel2-header"
				>
					<Typography component="span">Date Range Filter</Typography>
				</AccordionSummary>
				<AccordionDetails> */}
			{/* <LocalizationProvider dateAdapter={AdapterDayjs}>
				<DatePicker
					//label="Start Date"
					onChange={(date) => rangeStart(date)}
					className="date-picker"
					slotProps={{ textField: { size: "small" } }}
				/>
			</LocalizationProvider>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<DatePicker
					//label="End Date"
					onChange={(date) => rangeEnd(date)}
					className="date-picker"
					slotProps={{ textField: { size: "small" } }}
				/>
			</LocalizationProvider>
			{rangeErrMsg ? (
				<p style={{ color: "red", fontSize: "12px" }}>Invalid Date Range</p>
			) : null}
			<button
				className="filter-btn"
				onClick={() => rangeFetch()}
			>
				Filter
			</button> */}
			{/* </AccordionDetails>
			</Accordion> */}
		</div>
	);
};

export default HistoryFilter;
